import PropTypes from "prop-types";

import CheckIcon from "@/icons/CheckIcon";
import CloseIcon from "@/icons/CloseIcon";
import {
  rootCss,
  iconCss,
  labelColorCss,
  labelTextCss,
} from "./ActivityChoiceIndicator.style";

export const ActivityChoiceIndicatorColor = {
  primary: "primary",
  danger: "danger",
  success: "success",
};

export const ActivityChoiceIndicatorStatus = {
  primary: "primary",
  correct: "correct",
  incorrect: "incorrect",
};

const propTypes = {
  __cssFor: PropTypes.object,
  /**
   * The background color of the label
   */
  labelColor: PropTypes.oneOf(Object.values(ActivityChoiceIndicatorColor)),
  /**
   * Determines whether an icon should render next to the label text
   */
  status: PropTypes.oneOf(Object.values(ActivityChoiceIndicatorStatus)),
  text: PropTypes.string.isRequired,
};

const renderIcon = (labelStatus) => {
  switch (labelStatus) {
    case "correct":
      return <CheckIcon css={iconCss} />;
    case "incorrect":
      return <CloseIcon css={iconCss} />;
    case "primary":
    default:
      return null;
  }
};

const ActivityChoiceIndicator = (props) => {
  const { __cssFor, labelColor, status, text } = props;

  const choiceLabelCss = [rootCss, labelColorCss(labelColor), __cssFor];

  return (
    <div css={choiceLabelCss}>
      {renderIcon(status)}
      <span css={labelTextCss}>{text}</span>
    </div>
  );
};

ActivityChoiceIndicator.propTypes = propTypes;
ActivityChoiceIndicator.color = ActivityChoiceIndicatorColor;
ActivityChoiceIndicator.status = ActivityChoiceIndicatorStatus;

export default ActivityChoiceIndicator;
